import React, { useState,useEffect } from 'react';
import ClientList from '../components/client/ClientList';
import ClientForm from '../components/client/ClientForm';
import SingleClient from '../components/client/SingleClient';
import ClientDeleteButton from '../components/client/ClientDeleteButton';
import ClientUpdateForm from '../components/client/ClientupdateForm';

import BulkUploadClients from '../components/client/BulkUploadClients';


const ClientManagementPage = () => {
  const [currentView, setCurrentView] = useState('list');
  const [selectedClientId, setSelectedClientId] = useState(null);
 

  const handleSelectClient = (client) => {
    console.log(client);
    setSelectedClientId(client.id);
    setCurrentView('view');
  };


  return (
    <div>
      
      {currentView === 'create' && <ClientForm />}
      {currentView === 'update' && <ClientUpdateForm clientId={selectedClientId} />}
      {currentView === 'delete' && <ClientDeleteButton clientId={selectedClientId} onSuccess={() => setCurrentView('list')} />}
      {currentView === 'bulkUpload' && <BulkUploadClients />}
      {currentView === 'list' && <ClientList onSelectClient={handleSelectClient} />}
      {currentView === 'view' && selectedClientId && (
        <SingleClient clientId={selectedClientId} onChangeView={setCurrentView} />
      )}
    </div>
  );
};

export default ClientManagementPage;
